if (!customElements.get('image-zoom-modal')) {
  customElements.define(
    'image-zoom-modal',
    class ImageZoomModal extends HTMLElement {
      constructor() {
        super();
        // Don't call ModalDialog constructor to avoid querySelector error
      }
      
      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        
        this.modalContent = this.querySelector('.image-zoom-modal__content');
        this.modalImage = this.querySelector('.image-zoom-modal__image');
        
        // Add event listeners after elements are created
        const closeButton = this.querySelector('.image-zoom-modal__toggle');
        if (closeButton) {
          closeButton.addEventListener('click', () => this.hide());
        }
        
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        
        this.addEventListener('click', (event) => {
          // 点击modal背景（半透明区域）关闭modal
          if (event.target === this) {
            this.hide();
          }
        });
      }

      show(opener) {
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        this.loadImage(opener);
        
        // Focus management
        const dialogElement = this.querySelector('[role="dialog"]');
        if (dialogElement) {
          trapFocus(this, dialogElement);
        }
        window.pauseAllMedia();
      }
      
      hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
      }

      loadImage(opener) {
        const imageSrc = opener.getAttribute('data-image-src');
        const imageSubSrc = opener.getAttribute('data-image-sub-src');
        if ((imageSubSrc || imageSrc) && this.modalImage) {
          this.modalImage.src = imageSubSrc && !imageSubSrc.includes('invalid url') ? imageSubSrc : imageSrc;
          this.modalImage.alt = opener.querySelector('img')?.alt || 'Zoomed image';
        }
      }
    }
  );
}

// Initialize zoom functionality for multicolumn images
class MultiColumnImageZoom {
  constructor() {
    this.init();
  }

  init() {
    // Create modal if it doesn't exist
    this.createModal();
    
    // Add click listeners to zoomable images
    this.addClickListeners();
  }

  createModal() {
    if (document.querySelector('#ImageZoomModal')) return;

    const modal = document.createElement('image-zoom-modal');
    modal.id = 'ImageZoomModal';
    modal.className = 'image-zoom-modal';
    modal.innerHTML = `
      <span class="image-zoom-modal__toggle">&times;</span>
      <div class="image-zoom-modal__content" role="dialog" aria-modal="true" aria-label="Image preview">
        <img class="image-zoom-modal__image" src="" alt="" />
      </div>
    `;
    
    document.body.appendChild(modal);
  }

  addClickListeners() {
    document.addEventListener('click', (event) => {
      const zoomableImage = event.target.closest('.zoomable-column-image');
      
      if (zoomableImage && zoomableImage.getAttribute('data-image-src')) {
        event.preventDefault();
        const modal = document.querySelector('#ImageZoomModal');
        if (modal) {
          modal.show(zoomableImage);
        }
      }
    });
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MultiColumnImageZoom();
  });
} else {
  new MultiColumnImageZoom();
}